import React, { useEffect } from 'react'
import { Route } from 'react-router-dom'
import { PermissionsEnum } from '../../constants'
import { RouteProps } from 'react-router'
import { usePermissions } from '../../hooks'
import { getAppConfigSetting, navigateToExternalUrl } from '../../utils'

interface PermissionRouteProps extends RouteProps {
  requiredPermissions: PermissionsEnum[]
}

const PermissionRoute = ({
  requiredPermissions,
  ...remainingProps
}: PermissionRouteProps) => {
  const { hasPermission } = usePermissions()
  const canAccessRoute = requiredPermissions.every(hasPermission)

  useEffect(() => {
    if (!canAccessRoute) {
      navigateToExternalUrl(
        `${getAppConfigSetting('appsUrl')}/session/#/welcome`
      )
    }
  }, [canAccessRoute])

  return canAccessRoute ? <Route {...remainingProps} /> : null
}

export default PermissionRoute
